import { render, staticRenderFns } from "./CreatePix.vue?vue&type=template&id=befc95c8&scoped=true"
import script from "./CreatePix.vue?vue&type=script&lang=js"
export * from "./CreatePix.vue?vue&type=script&lang=js"
import style0 from "./CreatePix.vue?vue&type=style&index=0&id=befc95c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befc95c8",
  null
  
)

export default component.exports